import { useEffect, useRef } from "react";

import "./ContextMenu.css";

export default function ContextMenu({ x, y, items, onClose }) {
    const ref = useRef();

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose();
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [onClose]);

    // Clamp to viewport
    const style = {
        position: "fixed",
        top: Math.min(y, window.innerHeight - 220),
        left: Math.min(x, window.innerWidth - 200),
        zIndex: 9999,
    };

    return (
        <div className="context-menu" style={style} ref={ref}>
            {items.map((item, i) =>
                item === "divider" ? (
                    <div key={i} className="context-divider" />
                ) : (
                    <button
                        key={i}
                        className={`context-item ${item.danger ? "danger" : ""}`}
                        onClick={() => {
                            item.onClick();
                            onClose();
                        }}
                    >
                        <span className="context-icon">{item.icon}</span>
                        {item.label}
                    </button>
                ),
            )}
        </div>
    );
}
